import { Share, X } from "lucide-react";
import { useState } from "react";

const KEY = "artisan-install-hint-dismissed";

/** True for iPad / iPhone Safari used as a web page (not the installed home-screen app). iPadOS
 * reports itself as a Mac, so touch support tells them apart. */
export function needsInstall(): boolean {
  const nav = navigator as Navigator & { standalone?: boolean };
  const ios = /iPad|iPhone|iPod/.test(nav.userAgent) || (nav.platform === "MacIntel" && nav.maxTouchPoints > 1);
  return ios && !isInstalled();
}

/** Running as the installed (home-screen) app rather than a browser tab. */
export function isInstalled(): boolean {
  const nav = navigator as Navigator & { standalone?: boolean };
  return nav.standalone === true || window.matchMedia("(display-mode: standalone)").matches;
}

/** Safari keeps a web page's offline data only for a while; the app added to the Home Screen
 * keeps it, opens full-screen and works offline. Shown until the rep dismisses it. */
export function InstallHint() {
  const [open, setOpen] = useState(() => {
    try {
      return needsInstall() && localStorage.getItem(KEY) !== "1";
    } catch {
      return needsInstall();
    }
  });
  if (!open) return null;
  return (
    <div role="note" className="relative flex gap-3 rounded-xl border bg-primary-soft p-4 pr-12 text-sm">
      <Share className="mt-0.5 size-5 shrink-0 text-primary" aria-hidden />
      <p>
        <b className="font-semibold">Апп болгож суулгана уу.</b> Safari-ийн доод/дээд талын <b>Хуваалцах</b> товчийг дараад{" "}
        <b>«Нүүр дэлгэцэнд нэмэх»</b>-ийг сонгоно. Ингэснээр бүтэн дэлгэцээр нээгдэж, интернэтгүй үед ч өгөгдөл найдвартай хадгалагдана.
      </p>
      <button
        type="button"
        aria-label="Хаах"
        onClick={() => {
          try {
            localStorage.setItem(KEY, "1");
          } catch {
            /* private mode: the hint just comes back next time */
          }
          setOpen(false);
        }}
        className="absolute top-2 right-2 grid size-9 place-items-center rounded-md hover:bg-accent"
      >
        <X className="size-4" aria-hidden />
      </button>
    </div>
  );
}
